export enum KeyboardActions {
  PickFromLogYard = 'PickFromLogYard',
  LeaveInLogYard = 'LeaveInLogYard',
}
